import { ErrorBoundary } from "../components/error-boundary";
import { ProtectedRoutes } from "../components/protected-routes";
import { roles } from "../constants/roles";
import * as lazy from "./lazyLoadFiles";

export const routesData = [
  {
    path: "*",
    element: <>page Not found</>,
    role: [roles.admin, roles.student, roles.superAdmin, roles.teacher],
  },
  {
    path: "/loggedin",
    element: <lazy.LazyAzureLoginSuccess />,
    role: [roles.admin, roles.student, roles.superAdmin, roles.teacher],
  },
  {
    path: "/",
    element: (
      <ErrorBoundary fallback="something went wrong...">
        <lazy.LazyLogin />
      </ErrorBoundary>
    ),
    role: [roles.admin, roles.student, roles.superAdmin, roles.teacher],
  },
  {
    path: "/forgot-password",
    element: (
      <ErrorBoundary fallback="something went wrong...">
        <lazy.LazyForgotPassword />
      </ErrorBoundary>
    ),
    role: [roles.admin, roles.student, roles.superAdmin, roles.teacher],
  },
  {
    path: "/verify",
    element: (
      <ErrorBoundary fallback="something went wrong...">
        <lazy.LazyVerify />
      </ErrorBoundary>
    ),
    role: [roles.admin, roles.student, roles.superAdmin, roles.teacher],
  },
  {
    path: "/email-sent",
    element: (
      <ErrorBoundary fallback="something went wrong...">
        <lazy.LazyEmailSent />
      </ErrorBoundary>
    ),
    role: [roles.admin, roles.student, roles.superAdmin, roles.teacher],
  },

  {
    path: "/*",
    element: (
      <ProtectedRoutes>
        <ErrorBoundary fallback="something went wrong...">
          <lazy.LazyMainLayout />
        </ErrorBoundary>
      </ProtectedRoutes>
    ),
    role: [roles.admin, roles.student, roles.superAdmin, roles.teacher],
    children: [
      {
        path: "dashboard/*",
        element: <lazy.LazyDashboard />,
        role: [roles.admin, roles.superAdmin, roles.teacher],
        children: [
          {
            path: "general-overview",
            element: <lazy.LazyGeneralOverview />,
            role: [roles.admin, roles.superAdmin, roles.teacher],
          },
          {
            path: "student-performance-tracking",
            element: <lazy.LazyStudentPerformanceTracking />,
            role: [roles.admin, roles.superAdmin, roles.teacher],
          },
          {
            path: "top-students",
            element: <lazy.LazyStudentSpeciality />,
            role: [roles.admin, roles.superAdmin, roles.teacher],
          },
          {
            path: "performance-by-specialties",
            element: <lazy.LazyPerformanceBySpecialties />,
            role: [roles.admin, roles.superAdmin, roles.teacher],
          },
          {
            path: "performance-by-clinical-actions",
            element: <lazy.LazyPerformanceByClinicalActions />,
            role: [roles.admin, roles.superAdmin, roles.teacher],
          },
        ],
      },

      {
        path: "establishment",
        element: <lazy.LazyEstablishment />,
        role: [roles.superAdmin],
      },
      {
        path: "user-management/*",
        element: <lazy.LazyUserManagement />,
        role: [roles.superAdmin, roles.admin],
        children: [
          {
            path: "admins",
            element: <lazy.LazyUserAdmins />,
            role: [roles.superAdmin],
          },
          {
            path: "teachers",
            element: <lazy.LazyUserTeachers />,
            role: [roles.superAdmin, roles.admin],
          },
          {
            path: "students",
            element: <lazy.LazyStudents />,
            role: [roles.superAdmin, roles.admin],
          },
        ],
      },
      {
        path: "pathology",
        element: <lazy.LazyPathology />,
        role: [roles.superAdmin],
      },
      {
        path: "master-data",
        element: <lazy.LazyMasterData />,
        role: [roles.superAdmin],
      },
      {
        path: "case-management/*",
        element: <lazy.LazyCaseManagement />,
        role: [roles.admin, roles.teacher],
        children: [
          {
            path: "",
            element: <lazy.LazyCaseManagementDetails />,
            role: [roles.admin, roles.teacher],
          },
          {
            path: "create/*",
            element: <lazy.LazyCaseManagementCreate />,
            role: [roles.admin, roles.teacher],
            children: [
              {
                path: ":step",
                element: <lazy.LazyCaseManagementSteps />,
                role: [roles.admin, roles.teacher],
              },
            ],
          },
        ],
      },
      {
        path: "materials/*",
        element: <lazy.LazyMaterials />,
        role: [roles.superAdmin],
        children: [
          {
            path: "",
            element: <lazy.LazyMaterialsList />,
            role: [roles.superAdmin],
          },
          {
            path: "emergency-care-trolley-configuration ",
            element: <lazy.LazyTrolleyConfiguration />,
            role: [roles.superAdmin],
          },
          {
            path: "medical-trolley-configuration",
            element: <lazy.LazyTrolleyConfiguration />,
            role: [roles.superAdmin],
          },
          {
            path: "emergency-care-trolley-configuration",
            element: <lazy.LazyTrolleyConfiguration />,
            role: [roles.superAdmin],
          },
        ],
      },
      {
        path: "treatment",
        element: <lazy.LazyTreatment />,
        role: [roles.superAdmin],
      },
      {
        path: "specialty",
        element: <lazy.LazyMasterData />,
        role: [roles.superAdmin],
      },
      {
        path: "domain",
        element: <lazy.LazyMasterData />,
        role: [roles.superAdmin],
      },
      {
        path: "complimentary-examinations",
        element: <lazy.LazyComplimentaryExaminations />,
        role: [roles.superAdmin],
      },
      {
        path: "complimentary-examinations",
        element: <lazy.LazyComplimentaryExaminations />,
        role: [roles.superAdmin],
      },
      {
        path: "student-dashboard",
        element: <lazy.LazyStudentDashboard />,
        role: [roles.student],
      },
      // {
      //   path: "virtual-patient",
      //   element: <lazy.LazyVirtualPatient />,
      //   role: [roles.admin],
      // },
      {
        path: "seeding-panel",
        element: <lazy.LazySeedingPanelOutlet />,
        role: [roles.superAdmin],
        children: [
          {
            path: "",
            element: <lazy.LazySeedingPanelData />,
            role: [roles.superAdmin],
          },
          {
            path: "add-themes",
            element: <lazy.LazySeedingPanelAddThemes />,
            role: [roles.superAdmin],
          },
          {
            path: "edit-themes",
            element: <lazy.LazySeedingPanelAddThemes />,
            role: [roles.superAdmin],
          },
          {
            path: "organs-config",
            element: <lazy.LazyOrgansConfig />,
            role: [roles.superAdmin],
          },
        ],
      },
      {
        path: "target-groups",
        element: <lazy.LazyTargetGroups />,
        role: [roles.admin],
      },
      // {
      //   path: "clinical-case",
      //   element: <lazy.LazyClinicalCaseManagement />,
      //   role: [roles.teacher],
      // },
      {
        path: "monitor-peformance/*",
        element: <lazy.LazyMonitoringLearnerPeformance />,
        role: [roles.teacher],
        children: [
          {
            path: "",
            element: <lazy.LazyMonitoringPeformance />,
            role: [roles.teacher],
          },
          {
            path: "debriefing",
            element: <lazy.MonitorPeformanceDebriefing />,
            role: [roles.teacher],
          },
        ],
      },
      {
        path: "student-case/*",
        element: <lazy.LazyMonitoringPeformanceStudentClinical />,
        role: [roles.student],
        children: [
          {
            path: "",
            element: <lazy.LazyStudentClinicalCase />,
            role: [roles.student],
          },
          {
            path: "debriefing",
            element: <lazy.LazyStudentClinicalCaseDebriefing />,
            role: [roles.student],
          },
        ],
      },
      {
        path: "examination-room",
        element: <lazy.ExaminationRoom />,
        role: [roles.student, roles.admin, roles.teacher],
      },
      {
        path: "point-system",
        element: <lazy.LazyPointSystem />,
        role: [roles.admin],
      },
    ],
  },
];
